import React, { Component } from 'react';

class Legal extends Component {
  
  render() {

    const year = (new Date()).getFullYear();

    return (
      <div className="legal">
        <small>All contents &copy;{year} SLA Service Management</small>
      </div>
    );
  }
}

export default Legal;



// WEBPACK FOOTER //
// ./src/components/Legal/Legal.js